import React, { useEffect, useMemo } from 'react';
import {  getFilterSearchUrl } from '../../../utils';
import { getCategory } from '../../../apiCalls';

import Plan from './Plan';

const PlansListing = ({
  filteredPlans,
  selectedPlans,
  match,
  changeLocation,
  getProductInfo,
  addComparisonPlan,
  history,
  mobile,
  mobileActive,
  openModalQuotationDateWarning,
  userDetails,
  providers,
  showSpecialistSuggestions,
}) => {
  const firstPlan = useMemo(() => filteredPlans[0], [filteredPlans]);

  const isFirstPlanComparisionSelected = useMemo(() => {
    return !!selectedPlans.find((code) => code === firstPlan.code || '');
  }, [selectedPlans, firstPlan]);

  const isFirstPlanSpecialist = firstPlan.extra.specialist_indicator && showSpecialistSuggestions;

  useEffect(() => {
    getCategory(getFilterSearchUrl(window.location.search));
  }, []);

  return (
    <div className="tb-resultado-filtro" key={2}>
      <div
        className={`head-resultado-filtro flex${isFirstPlanSpecialist ? ' yellow-border' : ''}${
          isFirstPlanComparisionSelected ? ' purple-border' : ''
        } `}
      >
        <div className="item-head">
          <h3>Seguradora</h3>
        </div>
        <div className="item-head">
          <h3>Plano</h3>
        </div>
        <div className="item-head">
          <h3>Despesa médica e seguro bagagem</h3>
        </div>
        <div className="item-head flex">
          <h3>Total por segurado</h3>
        </div>
      </div>

      {filteredPlans.map((plan, i) => (
        <Plan
          plan={plan}
          key={plan.code}
          match={match}
          changeLocation={changeLocation}
          getProductInfo={getProductInfo}
          addComparisonPlan={addComparisonPlan}
          history={history}
          isSelected={selectedPlans.indexOf(plan.code.toString()) >= 0}
          mobile={mobile}
          mobileActive={() => mobileActive()}
          openModalQuotationDateWarning={() => openModalQuotationDateWarning()}
          userDetails={userDetails}
          position={i}
          providers={providers}
          showSpecialistSuggestions={showSpecialistSuggestions}
        />
      ))}
    </div>
  );
};

export default PlansListing;



// WEBPACK FOOTER //
// ./src/components/search/plans_table/PlansListing.jsx